import {
  THREE_SIXTY_LABLE,
  THREE_SIXTY_MAIN,
  THREE_SIXTY_CAROUSEL_LABLE,
} from "@/components/ImageGallery/v2/constants"

export const addAnalyticsClickPdpImageVideo = data => {
  const {
    index = 0,
    mediaType = "",
    imageVideoName = "",
    totalImages = 0,
    pdpType = "",
    assetId = "",
    resourceType = "n/a",
    productInfo = [],
  } = data

  const imageVideoIdKey = mediaType === "image reel" ? "imageId" : "videoId"
  const imageVideoNameKey =
    mediaType === "image reel" ? "imageName" : "videoName"

  const eventInfo = {
    eventAction: "pdp:product details:main image click",
    eventName: "pdp:product details:main image click",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: assetId,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${mediaType}`,
    internalLinkZoneName: "pdp:product details:image reel",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageSequence: `${index}_${totalImages}`,
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: imageVideoName,
    resourceType,
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsClickSliderImageVideo = data => {
  const {
    index = 0,
    imageVideoId = "n/a",
    totalImages = 0,
    pdpType = "",
    zoomEntryPoint = "image reel",
    imageName = "n/a",
    imageClick = false,
    resourceType = "n/a",
    isThreeSixtyImage = "",
    productInfo = [],
  } = data

  const imageVideoIdKey = imageClick ? "imageId" : "videoId"
  const imageVideoNameKey = imageClick ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:carousel image click",
    eventName: "pdp:product details:carousel image click",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: imageVideoId,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${zoomEntryPoint}${
      isThreeSixtyImage ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkZoneName: `pdp:product details:${zoomEntryPoint}${
      isThreeSixtyImage ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageSequence: `${index}_${totalImages}`,
    [imageVideoIdKey]: imageVideoId,
    [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
    resourceType,
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsClickCloseZoom = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    currentImageData = {},
    totalImages = "",
    resourceType = "n/a",
    isThreeSixty = "",
    productInfo = [],
  } = data

  const {
    type: mediaType = "",
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const imageVideoIdKey = !mediaType ? "imageId" : "videoId"
  const imageVideoNameKey = !mediaType ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:carousel image click:close button",
    eventName: "pdp:product details:carousel image click:close button",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${zoomEntryPoint}${
      isThreeSixty ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkZoneName: `pdp:product details:view gallery${
      isThreeSixty ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    resourceType,
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
    modalName: pdpType,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsClickZoomReset = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    currentImageData = {},
    totalImages = "",
    resourceType = "n/a",
    is360Image = "",
    threeSixtyImageClick = "",
    productInfo = [],
  } = data

  const {
    type: mediaType = "",
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const imageVideoIdKey = !mediaType ? "imageId" : "videoId"
  const imageVideoNameKey = !mediaType ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:zoom reset`,
    eventName: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:zoom reset`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "zoom reset:applied",
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${zoomEntryPoint ? zoomEntryPoint : "image reel"}${
      is360Image || threeSixtyImageClick ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkZoneName: `pdp:product details:view gallery${
      is360Image || threeSixtyImageClick ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    resourceType,
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
    modalName: pdpType,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsClickZoomSpinnerAndFullscreen = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image gallary",
    currentImageData = {},
    totalImages = "",
    resourceType = "n/a",
    is360Image = "",
    buttonType = "",
    threeSixtyImageClick = "",
    screenType,
    productInfo = [],
  } = data

  const linkName = buttonType || screenType

  const {
    type: mediaType = "",
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const imageVideoIdKey = !mediaType ? "imageId" : "videoId"
  const imageVideoNameKey = !mediaType ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:360 ${buttonType || screenType}`,
    eventName: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:360 ${buttonType || screenType}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: linkName,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${
      zoomEntryPoint ? zoomEntryPoint : "image gallary"
    }${is360Image || threeSixtyImageClick ? `:${THREE_SIXTY_LABLE}` : ""}`,
    internalLinkZoneName: `pdp:product details:image gallery${
      is360Image || threeSixtyImageClick ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    resourceType,
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
    modalName: pdpType,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsZoomImageSliderArrow = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    arrowLable = "right",
    resourceType = "n/a",
    productInfo = [],
  } = data

  const eventInfo = {
    eventAction: `pdp:product details:carousel image click:${arrowLable}`,
    eventName: `pdp:product details:carousel image click:${arrowLable}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${arrowLable} arrow`,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    resourceType,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsClickZoomImage = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    zoomAction = "zoom in",
    currentImageData = {},
    totalImages = 0,
    counter,
    resourceType = "n/a",
    is360Image = "",
    counterThreeSixty = "",
    productInfo,
  } = data

  const {
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const eventInfo = {
    eventAction: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:${zoomAction}`,
    eventName: `pdp:product details:${
      is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE
    } image click:${zoomAction}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${zoomAction}:applied`,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:${zoomEntryPoint}:${THREE_SIXTY_LABLE}`,
    internalLinkZoneName: `pdp:product details:${zoomEntryPoint}:${THREE_SIXTY_LABLE}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageId: assetId,
    resourceType,
    imageName: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
    zoomUsageDepth: `${zoomAction}_${counterThreeSixty || counter}`,
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsPdpSlider = data => {
  const {
    pdpImageInfo = {},
    totalImages = 0,
    pdpType = "",
    arrowLabel = "right",
    resourceType = "n/a",
    checkIs360Spin = "",
    productInfo = [],
  } = data

  const {
    label: imageName = "n/a",
    index: imageIndex = 0,
    type: imageType = "",
    assetId: imageAssetId = "",
    url: imageUrl = "",
  } = pdpImageInfo

  const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId"
  const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName"

  const eventInfo = {
    eventAction: `pdp:product details:slider main image click:${arrowLabel}`,
    eventName: `pdp:product details:slider main image click:${arrowLabel}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${arrowLabel} arrow`,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:image reel${
      checkIs360Spin ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkZoneName: `pdp:product details:image reel${
      checkIs360Spin ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    resourceType,
    imageSequence: `${imageIndex + 1}_${totalImages}`,
    [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
    [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}
export const addAnalyticsPdpSliderFilmStrip = data => {
  const {
    pdpImageInfo = {},
    totalImages = 0,
    pdpType = "",
    arrowLabel = "right",
    resourceType = "n/a",
    productInfo = [],
  } = data

  const {
    label: imageName = "n/a",
    index: imageIndex = 0,
    type: imageType = "",
    assetId: imageAssetId = "",
    url: imageUrl = "",
  } = pdpImageInfo

  const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId"
  const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName"

  const eventInfo = {
    eventAction: `pdp:product details:filmstrip main image click:${arrowLabel}`,
    eventName: `pdp:product details:filmstrip main image click:${arrowLabel}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${arrowLabel} arrow`,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: "pdp:image reel",
    internalLinkZoneName: "pdp:product details:image reel",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    resourceType,
    imageSequence: `${imageIndex + 1}_${totalImages}`,
    [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
    [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addPdpThumbnailAnylticsClick = data => {
  const {
    pdpType = "",
    currentIndex = "",
    totalImages = "",
    pdpImageInfo = {},
    resourceType = "n/a",
    productInfo = [],
  } = data
  const {
    label: imageName = "n/a",
    assetId: imageAssetId = "",
    type: imageType = "",
    url: imageUrl = "",
    resourceName = "",
    resourceAltText = "",
  } = pdpImageInfo
  const imageId = resourceName?.length ? resourceName?.[0] : imageAssetId
  const imageNamePdp = resourceAltText?.length
    ? resourceAltText?.[0]
    : imageName
  const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId"
  const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:thumbnail image click",
    eventName: "pdp:product details:thumbnail image click",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: imageId,
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: `pdp:image reel${
      resourceName ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkZoneName: `pdp:product details:image reel${
      resourceName ? `:${THREE_SIXTY_LABLE}` : ""
    }`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    [imageVideoIdKey]: imageType !== "video" ? imageId : imageUrl,
    [imageVideoNameKey]: imageNamePdp.toLowerCase() || "n/a",
    imageSequence: `${currentIndex}_${totalImages}`,
    resourceType,
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addViewGalleryAnylticsClick = data => {
  const { pdpType = "", productInfo = [] } = data

  const eventInfo = {
    eventAction: "pdp:product details:thumbnail image click:view gallery",
    eventName: "pdp:product details:thumbnail image click:view gallery",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view gallery",
    internalLinkPosition: `pdp:${pdpType}`,
    internalLinkType: "pdp:image reel",
    internalLinkZoneName: "pdp:product details:image reel",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    modalName: pdpType,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = []) => {
  const page = window.pageObj || {}
  const event = "cmp:click"
  let objDL = { event, eventInfo, page }

  if (productInfo) {
    productInfo.forEach(item => {
      item.productImageGallery = true
    })
    objDL = { ...objDL, productInfo: productInfo }
  }
  window.adobeDataLayer.push(objDL)
}
